<script setup lang="ts">
import { DropdownMenuTrigger } from "reka-ui"
</script>

<template>
  <DropdownMenuTrigger><slot /></DropdownMenuTrigger>
</template>
